export default __webpack_public_path__ + "static/media/marker_point_green.7920bc57.svg";